module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<select v-bind:name='name' v-bind:multiple='isMultiple' v-bind:id='id'>\n  <option v-if='includeBlank'></option>\n  <option v-for='option in collection' v-bind:value='option[1]' v-bind:data-selec2-id='option[1]'>\n    {{option[0]}}\n  </option>\n</select>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
